/**
 * 路由表（唯一真源）。
 *
 * 页面、导航、跳转一律引用这里，禁止在组件里手写路径字符串 ——
 * 改路径时只需要动这一个文件。
 */
export const ROUTES = {
  home: '/',
  textbooks: '/textbooks',
  /** 阅读页需要文章 id；不传则用于生成路由模板 */
  reader: (articleId: string = ':articleId') => `/read/${articleId}`,
  wordbook: '/wordbook',
  review: '/review',
  level: '/level',
  sentences: '/sentences',
  /** 学习建议：选一篇文章 + 一种学习模式，得到可执行的学习计划（阶段 7） */
  advice: '/advice',
  profile: '/me',
  admin: '/admin',
  login: '/login',
  register: '/register',
  copyright: '/copyright',
} as const;

/** 底部导航（移动端），只放最常用的入口。 */
export const BOTTOM_NAV_ITEMS = [
  { to: ROUTES.home, label: '首页', icon: 'home' },
  { to: ROUTES.textbooks, label: '教材', icon: 'book' },
  { to: ROUTES.wordbook, label: '生词本', icon: 'notebook' },
  { to: ROUTES.review, label: '复习', icon: 'repeat' },
  { to: ROUTES.profile, label: '我的', icon: 'user' },
] as const;

/** 顶栏与首页共用的完整导航。 */
export const MAIN_NAV_ITEMS = [
  { to: ROUTES.home, label: '首页' },
  { to: ROUTES.textbooks, label: '教材目录' },
  { to: ROUTES.wordbook, label: '生词本' },
  { to: ROUTES.review, label: '复习' },
  { to: ROUTES.level, label: '水平报告' },
  { to: ROUTES.sentences, label: '长难句' },
  { to: ROUTES.advice, label: '学习建议' },
] as const;
